import { WhatsAppContactCard } from "@/components/WhatsAppContactCard";

export function ContactPage() {
  return (
    <div className="mx-auto max-w-3xl px-4 py-14">
      <p className="text-xs font-bold uppercase tracking-[0.3em] text-brand-maroon">
        Contact
      </p>
      <h1 className="mt-2 font-display text-4xl font-bold text-brand-blue">
        Contact us
      </h1>
      <p className="mt-4 text-brand-blue/85">
        Reach the Old Boys’ Association secretariat using the details below.
      </p>

      <div className="mt-10 grid gap-6 md:grid-cols-2">
        <div className="rounded-2xl border border-brand-gray bg-brand-gray/40 p-6">
          <h2 className="font-display text-lg font-bold text-brand-blue">
            Secretariat
          </h2>
          <ul className="mt-4 space-y-2 text-sm text-brand-blue/90">
            <li>OBA Zahira College Mawanella</li>
            <li>
              Email:{" "}
              <a
                href="mailto:info@zcmoba.com"
                className="text-brand-maroon underline decoration-brand-maroon/30 underline-offset-2 hover:decoration-brand-maroon"
              >
                info@zcmoba.com
              </a>
            </li>
            <li>
              Phone:{" "}
              <a
                href="tel:+94766845050"
                className="text-brand-maroon underline decoration-brand-maroon/30 underline-offset-2 hover:decoration-brand-maroon"
              >
                076 684 5050
              </a>
            </li>
          </ul>
        </div>

        <WhatsAppContactCard
          title="WhatsApp"
          description="For general enquiries, membership questions, or a quick message to the secretariat, please contact us via WhatsApp."
          prefilledMessage="Hello, I have a general enquiry for the OBA Zahira College Mawanella secretariat."
          buttonLabel="Message us on WhatsApp"
        />
      </div>
    </div>
  );
}
